export const xinA = [
  [
    [113.67218893106212, 23.020781117284713, 10],
    [113.67220353406861, 23.020793094164386, 10],
  ],
  [
    [113.67225362768967, 23.020713533277167, 10],
    [113.67226823071181, 23.020725510133047, 10],
  ],
  [
    [113.67231832426128, 23.020645949233458, 10],
    [113.67233292728189, 23.020657926083473, 10],
  ],
  [
    [113.6723830207684, 23.020578365162564, 10],
    [113.67239762378748, 23.020590342006706, 10],
  ],
  [
    [113.67244771721963, 23.020510780965214, 10],
    [113.67246232022003, 23.0205227578214, 10],
  ],
  [
    [113.67251241358805, 23.02044319685004, 10],
    [113.67252701660628, 23.020455173680116, 10],
  ],
  [
    [113.67257710980518, 23.020375612696334, 10],
    [113.67259171281968, 23.020387589522873, 10],
  ],
  [
    [113.67264180605427, 23.020308028516656, 10],
    [113.67265640906724, 23.020320005337314, 10],
  ],
  [
    [113.6727065022475, 23.02024044421051, 10],
    [113.67272110524178, 23.02025242104323, 10],
  ],
  [
    [113.67277119836756, 23.020172859976448, 10],
    [113.67278580136033, 23.020184836803285, 10],
  ],
  [
    [113.67283589441456, 23.020105275724145, 10],
    [113.67285049742296, 23.020117252527186, 10],
  ],
  [
    [113.67290059039593, 23.020037691445804, 10],
    [113.67291519342218, 23.020049668222725, 10],
  ],
  [
    [113.67296528624325, 23.01997010702072, 10],
    [113.67297988923146, 23.019982083829937, 10],
  ],
  [
    [113.6730299821021, 23.019902522681235, 10],
    [113.67304458509521, 23.01991449947785, 10],
  ],
  [
    [113.67307340784157, 23.019857158077013, 10],
    [113.67308802237055, 23.019869122806853, 10],
  ],
  [
    [113.67313794999055, 23.019789491093473, 10],
    [113.67315261060078, 23.01980140741653, 10],
  ],
  [
    [113.6732022306614, 23.01972161109755, 10],
    [113.67321693714365, 23.01973347888505, 10],
  ],
  [
    [113.67326624886233, 23.01965351900872, 10],
    [113.67328100103907, 23.019665338098566, 10],
  ],
  [
    [113.6733300039102, 23.01958521572991, 10],
    [113.67334480160358, 23.01959698596008, 10],
  ],
  [
    [113.67339349493498, 23.019516702155016, 10],
    [113.67340833795038, 23.01952842338145, 10],
  ],
  [
    [113.67345672115596, 23.019447979006316, 10],
    [113.6734716092988, 23.019459651085, 10],
  ],
  [
    [113.6735196816946, 23.019379047276978, 10],
    [113.67353461477043, 23.01939067006393, 10],
  ],
  [
    [113.67358237585806, 23.019309907880594, 10],
    [113.67359735369162, 23.019321481210568, 10],
  ],
  [
    [113.6736448027872, 23.019240561608473, 10],
    [113.67365982516488, 23.019252085358737, 10],
  ],
  [
    [113.67370696167409, 23.019171009393755, 10],
    [113.67372202843647, 23.019182483381144, 10],
  ],
  [
    [113.6737688517729, 23.019101252100114, 10],
    [113.67378396269065, 23.01911267621993, 10],
  ],
  [
    [113.6738304722758, 23.019031290570673, 10],
    [113.67384562717375, 23.019042664657213, 10],
  ],
  [
    [113.67389182230623, 23.018961125886907, 10],
    [113.6739070210054, 23.018972449778442, 10],
  ],
  [
    [113.67395290120598, 23.01889075874252, 10],
    [113.6739681434776, 23.01890203233466, 10],
  ],
  [
    [113.67401370815992, 23.018820190080042, 10],
    [113.67402899384385, 23.018831413189147, 10],
  ],
  [
    [113.67407424232384, 23.01874942085295, 10],
    [113.67408957119163, 23.018760593374775, 10],
  ],
  [
    [113.67413450308554, 23.018678451904982, 10],
    [113.67414987496194, 23.01868957367322, 10],
  ],
  [
    [113.67419448948073, 23.01860728421566, 10],
    [113.67420990416716, 23.018618355091196, 10],
  ],
  [
    [113.67425420111053, 23.018535918463495, 10],
    [113.6742696580349, 23.018546938756216, 10],
  ],
  [
    [113.67428286287905, 23.018501474711222, 10],
    [113.67429833002278, 23.018512482707465, 10],
  ],
  [
    [113.67434232483566, 23.01842989009075, 10],
    [113.67435779198046, 23.018440898075994, 10],
  ],
  [
    [113.67440178663405, 23.018358305534733, 10],
    [113.67441725377556, 23.018369313514267, 10],
  ],
  [
    [113.67446124846717, 23.018286720955626, 10],
    [113.67447671560537, 23.018297728929436, 10],
  ],
  [
    [113.67452071013993, 23.01821513635332, 10],
    [113.67453617727482, 23.018226144321417, 10],
  ],
  [
    [113.67458017184018, 23.018143551736628, 10],
    [113.67459563898625, 23.018154559681555, 10],
  ],
  [
    [113.6746396333873, 23.018071967088023, 10],
    [113.67465510053009, 23.01808297502723, 10],
  ],
  [
    [113.67469909496916, 23.018000382416314, 10],
    [113.67471456210865, 23.018011390349805, 10],
  ],
  [
    [113.67475855639066, 23.017928797721414, 10],
    [113.67477402352684, 23.017939805649185, 10],
  ],
  [
    [113.67481801775878, 23.017857212992002, 10],
    [113.67483348487279, 23.017868220936766, 10],
  ],
  [
    [113.67487747914278, 23.017785628262203, 10],
    [113.67489294627234, 23.01779663617854, 10],
  ],
  [
    [113.67493694039256, 23.01771404338748, 10],
    [113.67495240748548, 23.017725051338253, 10],
  ],
  [
    [113.67499640165093, 23.017642458611384, 10],
    [113.67501186875941, 23.017653466533723, 10],
  ],
  [
    [113.67505586276779, 23.01757087378939, 10],
    [113.67507132985412, 23.017581881728724, 10],
  ],
  [
    [113.67511532390053, 23.017499288967006, 10],
    [113.67513079100242, 23.017510296877905, 10],
  ],
  [
    [113.6751747848751, 23.017427704118788, 10],
    [113.67519025198817, 23.01743871200652, 10],
  ],
  [
    [113.67523424589166, 23.01735611923875, 10],
    [113.67524971300142, 23.017367127120767, 10],
  ],
  [
    [113.67529370674785, 23.017284534335523, 10],
    [113.67530917385432, 23.017295542211823, 10],
  ],
  [
    [113.67535316763876, 23.017212949409195, 10],
    [113.67536863474194, 23.01722395727978, 10],
  ],
  [
    [113.67541262836934, 23.017141364459675, 10],
    [113.67542809546921, 23.017152372324524, 10],
  ],
  [
    [113.67547208914195, 23.01706977938803, 10],
    [113.67548755622403, 23.017080787264614, 10],
  ],
  [
    [113.6755315497578, 23.016998194379084, 10],
    [113.67554701681478, 23.01700920227622, 10],
  ],
];
